import React from 'react';
import Alert from '@mui/material/Alert';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';

/**
 * Displays an informational alert prompting the user to choose an institution.
 *
 * @param {string} message - Message displayed after the "Choose an institution" link.
 * @param {object} [sx] - MUI style overrides for the Alert component.
 */
function InstitutionPromptAlert({ message, sx }) {
  return (
    <Alert severity="info" sx={sx}>
      <Link
        component={RouterLink}
        to="/"
        underline="hover"
        color="primary"
        fontWeight="bold"
      >
        Choose an institution
      </Link>{' '}
      {message}
    </Alert>
  );
}

export default InstitutionPromptAlert;
